module.exports = __webpack_public_path__ + "media/images/press_kit/shoretime_bg/email/main-cc1a37513a75d3e4113a94f11634bde6.png";